module.exports = __webpack_public_path__ + "static/media/employee-manager.aee94c0a.png";